import { render, staticRenderFns } from "./Pay2CoinTransaction.vue?vue&type=template&id=062a05c1"
import script from "./Pay2CoinTransaction.vue?vue&type=script&lang=js"
export * from "./Pay2CoinTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports